import React, {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../models'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
interface Props {
  loading?: boolean
  generateTicket?: () => void
  deleteClick?: () => void
  textComponentGo?: string
  textComponentBack?: string
  reception?: () => void
  option?: string
  deleteButtonDisabled?: boolean
  deleteButtonFunc?: () => boolean
}
const ActionsContent = ({
  loading,
  generateTicket,
  deleteClick,
  reception,
  textComponentGo = '',
  textComponentBack = '',
  option = '',
  deleteButtonDisabled = false,
  deleteButtonFunc,
}: Props) => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLimpieza()
  const {reset} = useFormContext()
  const handleShowNewForm = () => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      isNew: true,
      content: {
        headerPanel: textComponentGo,
      },
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          isView: false,
        },
      },
    }
    changeCurrentTabItem(obj)
    reset()
  }
  const handleBack = () => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      content: {
        headerPanel: textComponentBack,
      },
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleRestText = () => {
    reset()
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      reset: true,
    }
    changeCurrentTabItem(obj)
  }

  let getDisabledDelete

  if (deleteButtonDisabled) {
    getDisabledDelete = deleteButtonFunc()
  } else {
    getDisabledDelete = currentTabItem.idToDelete ? false : true
  }

  return (
    <ButtonWrapper>
      {currentTabItem.content.headerPanel === textComponentBack && isAllowed('NUEVO') && (
        <Button label='Nuevo' onClick={handleShowNewForm} />
      )}
      {option !== 'appOrder' &&
        (currentTabItem.content.headerPanel === textComponentGo || currentTabItem.showPanel) && (
          <Button typeBtn='submit' label='Guardar' loading={loading} disabled={loading} />
        )}
      {option !== 'appOrder' && currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Limpiar' onClick={() => handleRestText()} />
      )}
      {isAllowed('ELIMINAR') && (
        <Button label='Eliminar' disabled={getDisabledDelete} onClick={deleteClick} />
      )}
      {currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Volver al listado' classNameProp='ms-auto' onClick={handleBack} />
      )}
    </ButtonWrapper>
  )
}

export default ActionsContent
